import { render, staticRenderFns } from "./MasterPayerList.vue?vue&type=template&id=06cbd059&"
import script from "./MasterPayerList.vue?vue&type=script&lang=js&"
export * from "./MasterPayerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports